import { useState } from 'react';

import { useDrawerControls } from 'components/common/zolaUI/Drawer';

export function useBudgetUnsavedChanges(
  callback: () => void,
  pathname: string
): { hasUnsavedChanges: boolean; setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void } {
  const [hasUnsavedChanges, setLocalHasUnsavedChanges] = useState(false);
  const { setOnUnsavedChanges, setShowSavePrompt } = useDrawerControls();

  const setHasUnsavedChanges = (hasUnsaved: boolean) => {
    if (hasUnsaved) {
      if (!hasUnsavedChanges) {
        setOnUnsavedChanges({
          key: pathname,
          onUnsavedChanges: () => {
            callback();
            setShowSavePrompt(true);
          },
        });
        setLocalHasUnsavedChanges(true);
      }
    } else {
      setShowSavePrompt(false);
      setOnUnsavedChanges({
        key: pathname,
      });
      setLocalHasUnsavedChanges(false);
    }
  };

  return { hasUnsavedChanges, setHasUnsavedChanges: newValue => setHasUnsavedChanges(newValue) };
}

export default useBudgetUnsavedChanges;
